import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { clearSelectedFilter } from '../../actions/homepageFeaturedContentActions';

import styles from './styles.scss';

// eslint-disable-next-line react/no-deprecated
class HomepageKnockout extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    clearSelectedFilter: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (this.props.visible) {
      window.addEventListener('scroll', this.onScroll);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.visible && !nextProps.visible) {
      window.removeEventListener('scroll', this.onScroll);
    } else if (!this.props.visible && nextProps.visible) {
      window.addEventListener('scroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    if (this.props.visible) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  onScroll = () => {
    const headingDown = this.pastScrollY && this.pastScrollY < window.scrollY;

    if (headingDown && window.scrollY > 200) {
      this.props.clearSelectedFilter();
      this.pastScrollY = undefined;
    } else {
      this.pastScrollY = window.scrollY;
    }
  };

  render() {
    return (
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
        onClick={this.props.clearSelectedFilter}
        className={classnames(styles.curtain, { [styles.visible]: this.props.visible })}
      />
    );
  }
}

export default connect(
  (state) => ({
    visible: !!state.homepageFeaturedContent.filter,
  }),
  (dispatch) => ({
    clearSelectedFilter: (location) => dispatch(clearSelectedFilter(location)),
  }),
)(HomepageKnockout);
